//This file is automatically rebuilt by the Cesium build process.
export default "/**\n\
 * The automatic GLSL constant for {@link Pass#OPAQUE}\n\
 *\n\
 * @name czm_passOpaque\n\
 * @glslConstant\n\
 *\n\
 * @see czm_pass\n\
 */\n\
const float czm_passOpaque = 8.0;\n\
";
